import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSearchParameter from 'hooks/useSearchParameter';
import config from 'utils/config';
import { openMindsetCoachingPanel } from 'utils/mindset';
function useCoachDeepLink() {
  var navigate = useNavigate();
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    coachQ = _useSearchParameter2[0];
  var _useSearchParameter3 = useSearchParameter('skillName'),
    _useSearchParameter4 = _slicedToArray(_useSearchParameter3, 1),
    coachSkillName = _useSearchParameter4[0];
  var _useSearchParameter5 = useSearchParameter('coachingContext'),
    _useSearchParameter6 = _slicedToArray(_useSearchParameter5, 1),
    coachingContext = _useSearchParameter6[0];
  useEffect(function () {
    if (!coachQ) return;
    if (config.isTrialHub) {
      openMindsetCoachingPanel({
        skillName: coachSkillName ? String(coachSkillName) : undefined,
        coachingContext: coachingContext ? String(coachingContext) : ''
      });
    } else {
      navigate("/coach-ai?q=".concat(encodeURIComponent(coachQ), "&skillName=").concat(encodeURIComponent(coachSkillName || ''), "&coachingContext=").concat(encodeURIComponent(coachingContext || '')), {
        replace: true
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
export default useCoachDeepLink;